import { Card } from '../../models/communication/cards.enum';
import { CardPosition, HandValue, SidePosition } from '../../models/communication/games.model';

export interface GameViewModel {
    title: { text: string; isSpecial: boolean };
    sides: SideModel[];
    hands: HandModel[];
    cards: CardModel[];
}

export interface SideModel {
    position: SidePosition;
    hands: HandModel[];
    state: SideState;
}

export interface HandModel {
    parentSide: SideModel;
    amountKey?: HandValue;
    sideIndex: number;
    label: string;
    state: HandState;
    cards: CardModel[];
    amount: { value: number; visible: boolean };
}

export interface CardModel {
    position: CardPosition;
    parentHand: HandModel;
    state: CardState;
    value: Card;
    isRotated: boolean;
    isCompact: boolean;
}

export enum CardState {
    Show = 'show',
    Back = 'back',
    Checked = 'checked',
    Hidden = 'hidden',
    Empty = 'empty',
    Muted = 'muted',
    MessageFaceDown = 'message-face-down',
    MessageFaceUp = 'message-face-up',
    MessageFlipCard = 'message-flip-card'
}

export enum SideState {
    Default = 'default',
    Current = 'current',
    Muted = 'muted',
    Win = 'win',
    Tie = 'tie'
}

export enum HandState {
    Default = 'default',
    Muted = 'muted'
}
